  <template>
    <v-layout pa-0 fill-height>
      <v-flex xs12>
        <v-card>
          <!-- TOOLBAR -->
          <v-toolbar
              dark
              color="primary"
          >
            <v-btn
                icon
                dark
                @click="discardAndExit()"
            >
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $t('settings.title') }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                  dark
                  flat
                  @click="saveAndExit()"
              >
                Save
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-layout row wrap pa-3 justify-center>
            <v-flex xs12 md4>
              <v-list>
                <v-list-tile class="pa-2"
                             v-for="settingsCategory in settingsCategories"
                             :key="settingsCategory.title"
                             v-model="settingsCategory.active"
                             avatar
                             active-class="default-class selected-item"
                             @click="selectSettingsCategory(settingsCategory)"
                >
                  <v-list-tile-avatar>
                    <v-icon :class="[settingsCategory.iconClass]">{{ settingsCategory.icon }}
                    </v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ settingsCategory.title }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ settingsCategory.description }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-divider vertical></v-divider>
            <v-flex xs12 md7>
              <!-- GENERAL -->
              <v-list v-show="selectedSettingsCategory.id === 'general'"
                      three-line
                      subheader
              >
                <div class="title pa-3">{{ $t('settings.language.header') }}</div>
                <v-list-tile avatar>
                  <v-list-tile-action class="ml-2">
                    <v-icon>mdi-translate</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="mt-4">
                    <SelectImageChooser :options="generalLanguageOptions"
                                        :currentSelection="settings.general.language.current"
                                        :items="generalAvailableLocales"></SelectImageChooser>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>


              <!-- DIALOGIC PLATFORM -->
              <v-list v-show="selectedSettingsCategory.id === 'dialogs'"
                      three-line
                      subheader
              >
                <div class="title pa-3">{{ $t('settings.dialogicPlatform.header') }}</div>
                <v-list-tile avatar>
                  <v-list-tile-action class="ml-2">
                    <v-icon>mdi-translate</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content class="mt-4">
                    <SelectImageChooser :options="chatbotLanguageOptions"
                                        :currentSelection="settings.chatbot.language.current"
                                        :items="chatbotAvailableLocales"></SelectImageChooser>
                  </v-list-tile-content>
                </v-list-tile>

                <v-list-tile avatar>
                  <v-list-tile-action>
                    <v-checkbox
                        v-model="userChatbotSettings.buttons"></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>Enable buttons
                    </v-list-tile-title>
                    <v-list-tile-sub-title>Enable the appearance of buttons for a guided flow of the conversation
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>


                <!--<v-list-tile avatar>
                    <v-list-tile-action class="ml-2">
                        <v-icon>mdi-translate</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content class="mt-4">
                        <SelectImageChooser :options="chatbotAudioLanguageOptions"
                                            :currentSelection="settings.chatbot.audio.language.current"
                                            :items="chatbotAudioAvailableLocales"></SelectImageChooser>
                    </v-list-tile-content>
                </v-list-tile>-->

                <!--<v-list-tile avatar>
                    <v-list-tile-action class="ml-2">
                        <v-icon>mdi-translate</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content class="mt-4">
                        <SelectImageChooser :options="chatbotEngineOptions"
                                            :currentSelection="settings.chatbot.engine.current"
                                            :items="availableChatbotEngines"></SelectImageChooser>
                    </v-list-tile-content>
                </v-list-tile>-->

                <!--<v-list-tile avatar>
                    <v-list-tile-action>
                        <v-checkbox
                                v-model="settings.chatbot.enableAdvanced.current"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t('settings.dialogicPlatform.advanced.enable') }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ $t('settings.dialogicPlatform.advanced.description')
                            }}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile avatar>
                    <v-list-tile-action>
                        <v-checkbox
                                v-model="settings.chatbot.enableWikipedia.current"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t('settings.dialogicPlatform.wikipedia.enable') }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ $t('settings.dialogicPlatform.wikipedia.description')
                            }}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile avatar>
                    <v-list-tile-action>
                        <v-checkbox
                                v-model="settings.chatbot.audio.enable.current"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t('settings.dialogicPlatform.audio.enable') }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ $t('settings.dialogicPlatform.audio.description')
                            }}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile avatar>
                    <v-list-tile-action>
                        <v-checkbox
                                v-model="settings.chatbot.enableConsole.current"></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>{{ $t('settings.dialogicPlatform.console.enable') }}
                        </v-list-tile-title>
                        <v-list-tile-sub-title>{{ $t('settings.dialogicPlatform.console.description')
                            }}
                        </v-list-tile-sub-title>
                    </v-list-tile-content>
                </v-list-tile>-->


              </v-list>


              <!--<v-list
                      three-line
                      subheader
              >
                  <v-subheader>Files</v-subheader>
                  <v-list-tile avatar>
                      <v-list-tile-action>
                          <v-checkbox v-model="settings.files.pdfViewer"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                          <v-list-tile-title>Enable Advanced PDF-viewer</v-list-tile-title>
                          <v-list-tile-sub-title>The files can be viewed through an advanced PDF-viewer. No PDF files will be transformed into PDFs to be shown.</v-list-tile-sub-title>
                      </v-list-tile-content>
                  </v-list-tile>
              </v-list>-->


              <!-- EMAIL ROUTING SETTINGS -->
              <v-list v-show="selectedSettingsCategory.id === 'emails'"
                      three-line
                      subheader
              >
                <div class="title pa-3">{{ $t('settings.notificationsType.header') }}</div>
                <v-list-tile avatar>
                  <v-list-tile-action class="ml-2">
                    <v-icon>mdi-translate</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <SelectImageChooser ref="notificationsTypeSelection"
                                        :options="NotificationsTypeOptions"
                                        :currentSelection="userChatbotSettings.notificationsType.current.description"
                                        :items="generalNotificationsType"></SelectImageChooser>
                  </v-list-tile-content>


                </v-list-tile>

                <v-container fluid>
                  <div class="subtitle">Preferences</div>
                  <v-list>
                    <v-list-tile avatar>

                    <v-list-tile-action>
                      <v-checkbox
                        v-model="checkboxCountry"
                    ></v-checkbox>
                    </v-list-tile-action>

                        <v-layout row align-center>
                          <v-flex xs12 sm6 class="pa-3">

                          <v-list-tile-title>Enable country</v-list-tile-title>
                          <v-list-tile-sub-title>Enable filtering of startup notifications by country</v-list-tile-sub-title>

                          </v-flex>
                          <v-flex xs12 sm6 md4 class="pa-3">
                        <v-select
                            v-model="notificationsCountry"
                            :items="countries"
                            label="Country"
                            :menu-props="{ offsetY: true }"
                            required
                            item-text="country"
                            item-value="country"
                            return-object
                            @change="changeCountry"
                            :disabled="!checkboxCountry"
                        />
                          </v-flex>
          </v-layout>
                    </v-list-tile>
                  </v-list>

                  <v-list>
                    <v-list-tile avatar>
                      <v-list-tile-action>
                    <v-checkbox
                        v-model="checkboxIndustry"
                    ></v-checkbox>
                      </v-list-tile-action>
                      <v-layout row align-center>
                        <v-flex xs12 sm6 class="pa-3">
                      <div>
                        <v-list-tile-title>Enable industry
                        </v-list-tile-title>
                        <v-list-tile-sub-title>Enable filtering of startup notifications by industry
                        </v-list-tile-sub-title>
                      </div>
                        </v-flex>
                          <v-flex xs12 sm6 md4 class="pa-3">

                        <v-select :disabled="!checkboxIndustry"
                                  v-model="notificationsIndustry"
                                  :items="Object.values(markets)"
                                  label="Industry"
                                  :menu-props="{ offsetY: true }"
                                  required
                                  item-text="industry"
                                  item-value="industry"
                                  return-object
                                  multiple
                                  @change="changeIndustry"
                        >
                          <template v-slot:prepend-item>

                            <v-list-tile
                                ripple
                                @click="selectAllMarket"
                            >
                              <v-list-tile-action>
                                <v-checkbox v-model="selectedAllMarkets"
                                >
                                </v-checkbox>
                              </v-list-tile-action>
                              <v-list-tile-content style="font-weight: bold">
                                <template v-if="selectedAllMarkets" >
                                  Deselect all
                                </template>
                                <template v-else>
                                  Select all
                                </template>
                              </v-list-tile-content>
                            </v-list-tile>
                          </template>
                          <template v-slot:selection="{ item, index }">
                            <v-text v-if="index === 0" class="ma-2">
                              {{ item }}
                            </v-text>
                            <span v-else-if="index === 1" class="ma-2">
        +{{ notificationsIndustry.length - 1 }} more
      </span>
                          </template>
                        </v-select>
                          </v-flex>
                      </v-layout>
                    </v-list-tile>

                  </v-list>

                  <!--Technology-->
                  <v-list>
                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                            v-model="checkboxTech"
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-layout row align-center>
                        <v-flex xs12 sm6 class="pa-3">
                          <div>
                            <v-list-tile-title>Enable technology
                            </v-list-tile-title>
                            <v-list-tile-sub-title>Enable filtering of startup notifications by technology
                            </v-list-tile-sub-title>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm6 md4 class="pa-3">

                          <v-select :disabled="!checkboxTech"
                                    v-model="notificationsTech"
                                    :items="technologies"
                                    label="Tech"
                                    :menu-props="{ offsetY: true }"
                                    required
                                    item-text="tech"
                                    item-value="tech"
                                    return-object
                                    multiple
                                    @change="changeTech"
                          >
                            <template v-slot:prepend-item>

                              <v-list-tile
                                  ripple
                                  @click="selectAllTech"
                              >
                                <v-list-tile-action>
                                  <v-checkbox v-model="selectedAllTechs"
                                  >
                                  </v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content style="font-weight: bold">
                                  <template v-if="selectedAllTechs" >
                                    Deselect all
                                  </template>
                                  <template v-else>
                                    Select all
                                  </template>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                            <template v-slot:selection="{ item, index }">
                              <v-text v-if="index === 0" class="ma-2">
                                {{ item }}
                              </v-text>
                              <span v-else-if="index === 1" class="ma-2">
        +{{ notificationsTech.length - 1 }} more
      </span>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>

                  </v-list>

                  <!--Opcos-->
                  <v-list>
                    <v-list-tile avatar>
                      <v-list-tile-action>
                        <v-checkbox
                            v-model="checkboxOpco"
                        ></v-checkbox>
                      </v-list-tile-action>
                      <v-layout row align-center>
                        <v-flex xs12 sm6 class="pa-3">
                          <div>
                            <v-list-tile-title>Enable Opco
                            </v-list-tile-title>
                            <v-list-tile-sub-title>Enable filtering of startup notifications by opcos
                            </v-list-tile-sub-title>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm6 md4 class="pa-3">

                          <v-select :disabled="!checkboxOpco"
                                    v-model="notificationsOpco"
                                    :items="Object.values(opcos)"
                                    label="Opco"
                                    :menu-props="{ offsetY: true }"
                                    required
                                    item-text="opco"
                                    item-value="opco"
                                    return-object
                                    multiple
                                    @change="changeOpco"
                          >
                            <template v-slot:prepend-item>

                              <v-list-tile
                                  ripple
                                  @click="selectAllOpco"
                              >
                                <v-list-tile-action>
                                  <v-checkbox v-model="selectedAllOpcos"
                                  >
                                  </v-checkbox>
                                </v-list-tile-action>
                                <v-list-tile-content style="font-weight: bold">
                                  <template v-if="selectedAllOpcos" >
                                    Deselect all
                                  </template>
                                  <template v-else>
                                    Select all
                                  </template>
                                </v-list-tile-content>
                              </v-list-tile>
                            </template>
                            <template v-slot:selection="{ item, index }">
                              <v-text v-if="index === 0" class="ma-2">
                                {{ item }}
                              </v-text>
                              <span v-else-if="index === 1" class="ma-2">
        +{{ notificationsOpco.length - 1 }} more
      </span>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </v-list-tile>

                  </v-list>


                </v-container>

              </v-list>


              <!-- WEB RADAR SETTINGS -->
              <v-list v-show="selectedSettingsCategory.id === 'web-radar'"
                      three-line
                      subheader
              >
                <div class="title pa-3">{{ $t('settings.webInformationRetrieval.header') }}</div>
                <v-list-tile avatar>
                  <v-list-tile-action>
                    <v-checkbox
                        v-model="settings.web.enableWebInformationRetrieval.current"></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ $t('settings.webInformationRetrieval.enable') }}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>{{
                        $t('settings.webInformationRetrieval.description')
                      }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>


              <!-- IMAGE CAPTIONING SETTINGS-->
              <!-- TO DO - FUTURE USE -->
              <!--<v-list v-show="selectedSettingsCategory.id === 'image-captioning'"
                      three-line
                      subheader
              >
                  <div class="title pa-3">{{ $t('settings.imageCaptioning.header') }}</div>
                  <v-list-tile avatar>
                      <v-list-tile-action>
                          <v-checkbox
                                  v-model="settings.imageCaptioning.enableImageCaptioning.current"></v-checkbox>
                      </v-list-tile-action>
                      <v-list-tile-content>
                          <v-list-tile-title>{{ $t('settings.imageCaptioning.enable') }}
                          </v-list-tile-title>
                          <v-list-tile-sub-title>{{ $t('settings.imageCaptioning.description') }}
                          </v-list-tile-sub-title>
                      </v-list-tile-content>
                  </v-list-tile>
              </v-list>-->

            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </template>

  <script>
  import {mapGetters, mapState} from 'vuex';
  import i18n from '@/plugins/i18n.js';
  import SettingsService from "@/helpers/SettingsService";
  import RouterService from "@/helpers/RouterService";

  import SelectImageChooser from "@/components/Inputs/SelectImageChooser";
  import UrlsService from "@/helpers/UrlsService";
  import TimeService from "@/helpers/TimeService";
  import APILoaderDecoratorService from "@/helpers/APILoaderDecoratorService";
  import countryList from "country-list";
  import _ from "lodash";
  import {values} from "@/utils/values";

  export default {
    name: 'Settings',
    components: {SelectImageChooser},
    props: {
      categoryId: {
        type: Number, default: 0
      },
    },

    created() {
      this.getMarkets();
      this.getOpcos();
      if (!this.userChatbotSettings.notificationsType.current.description) {
        this.userChatbotSettings.notificationsType.current.description = this.userChatbotSettings.notificationsType.previous.description
      }
      this.selectSettingsCategory(this.settingsCategories[this.categoryId]);
      this.countries = countryList.getNames().sort();
      this.checkboxCountry = !!this.userChatbotSettings.notificationsCountry
      this.notificationsCountry = this.userChatbotSettings.notificationsCountry
      console.log("this.userChatbotSettings: ",this.userChatbotSettings);
      this.checkboxIndustry = !!this.userChatbotSettings.notificationsIndustry;
      this.notificationsIndustry = this.userChatbotSettings.notificationsIndustry ? this.userChatbotSettings.notificationsIndustry : null
      this.checkboxTech = !!this.userChatbotSettings.notificationsTech;
      this.notificationsTech = this.userChatbotSettings.notificationsTech ? this.userChatbotSettings.notificationsTech : null
      this.checkboxOpco = !!this.userChatbotSettings.notificationsOpco;
      this.notificationsOpco = this.userChatbotSettings.notificationsOpco ? this.userChatbotSettings.notificationsOpco : null

      if (_.isEqual(this.notificationsTech,this.technologies)) {
        this.selectedAllTechs = true;
      }

    },
    data() {
      return {
        selectedAllMarkets: false,
        selectedAllTechs: false,
        selectedAllOpcos: false,
        markets: [],//values.markets,//["Energy", "Manufacturing", "Telco", "Media", "PA", "Insurance", "Banking", "Retail", "Cross", "Transport"],
        checkboxCountry: false,
        checkboxIndustry: false,
        checkboxTech: false,
        checkboxOpco: false,
        notificationsCountry: null,
        notificationsIndustry: null,
        notificationsTech: null,
        notificationsOpco: null,
        notificationsTypeItemMapping: {
          "On startup registration": 0,
          "Weekly report": 1
        },
        countries: [],
        technologies: values.techAreas,
        opcos: [],
        selectedSettingsCategory: null,
        generalLanguageOptions: {
          label: this.$t('settings.language.chooseLanguage'),
          solo: false,
          changeCallback: this.changeLocale,
        },
        NotificationsTypeOptions: {
          label: this.$t('settings.notificationsType.chooseNotificationsType'),
          solo: false,
          changeCallback: this.changeLocale,
        },
        chatbotLanguageOptions: {
          label: this.$t('settings.dialogicPlatform.chooseLanguage'),
          solo: false,
          changeCallback: this.setChatbotLocale,
        },
        chatbotEngineOptions: {
          label: this.$t('settings.dialogicPlatform.engine.chooseEngine'),
          solo: false,
          changeCallback: this.setChatbotEngine,
        },
        chatbotAudioLanguageOptions: {
          label: this.$t('settings.dialogicPlatform.audio.chooseLanguage'),
          solo: false,
          changeCallback: this.setChatbotAudioLocale,
        },
        settingsCategoriesAll: {
          IVE_ADMIN: [],
          ADMIN: [
            {
              id: 'general',
              title: 'General',
              description: 'General settings',
              icon: 'mdi-settings',
              iconClass: 'blue white--text',
              active: true,
            },
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
            {
              id: 'emails',
              title: 'E-mails',
              description: 'Settings for automatic notification by email',
              icon: 'mdi-email',
              iconClass: 'red white--text',
              active: false,
            },
            {
              id: 'web-radar',
              title: 'Web Radar',
              description: 'Settings of the Web Information Retrieval',
              icon: 'mdi-search-web',
              iconClass: 'green white--text',
              active: false,
            },
            /*{
            id: 'image-captioning',
            title: 'Image Captioning',
            description: 'Settings of the Image Captioning',
            icon: 'mdi-image-search',
            iconClass: 'yellow white--text',
            active: false,
        },*/
          ],
          USER: [
            {
              id: 'general',
              title: 'General',
              description: 'General settings',
              icon: 'mdi-settings',
              iconClass: 'blue white--text',
              active: true,
            },
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
          ],
          USER_CHAT: [
            {
              id: 'general',
              title: 'General',
              description: 'General settings',
              icon: 'mdi-settings',
              iconClass: 'blue white--text',
              active: true,
            },
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
          ],
          ADMIN_INNOVATION: [
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
            {
              id: 'emails',
              title: 'E-mails',
              description: 'Settings for automatic notification by email',
              icon: 'mdi-email',
              iconClass: 'red white--text',
              active: false,
            },
          ],
          APPROVER_INNOVATION: [
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
            {
              id: 'emails',
              title: 'E-mails',
              description: 'Settings for automatic notification by email',
              icon: 'mdi-email',
              iconClass: 'red white--text',
              active: false,
            },
          ],
           RADAR_INNOVATION: [
            /*{
               id: 'web-radar',
               title: 'Web Radar',
               description: 'Settings of the Web Information Retrieval',
               icon: 'mdi-search-web',
               iconClass: 'green white--text',
               active: false,
            },*/
            {
              id: 'general',
              title: 'General',
              description: 'General settings',
              icon: 'mdi-settings',
              iconClass: 'blue white--text',
              active: true,
            },
           ],

          USER_INNOVATION: [
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
            {
              id: 'emails',
              title: 'E-mails',
              description: 'Settings for automatic notification by email',
              icon: 'mdi-email',
              iconClass: 'red white--text',
              active: false,
            },
          ],
          CUSTOMER_CHAT_INNOVATION: [
            {
              id: 'dialogs',
              title: 'Dialogic Platform',
              description: 'Settings of the Dialogic Platform',
              icon: 'mdi-message',
              iconClass: 'orange white--text',
              active: false,
            },
            {
              id: 'emails',
              title: 'E-mails',
              description: 'Settings for automatic notification by email',
              icon: 'mdi-email',
              iconClass: 'red white--text',
              active: false,
            },
          ]
        }
      }
    },
    computed: {
      ...mapState({}),
      ...mapGetters('UserState', {
            settings: 'getSettings',
            userInfo: 'getUserInfo',
          }
      ),
      ...mapGetters('AppState', {
            availableLocales: 'getAvailableLocales',
            availableNotificationsType: 'getAvailableNotificationsType',
            availableChatbotEngines: 'getAvailableChatbotEngines',
            userChatbotSettings: 'getSettings'
          }
      ),
      ...mapGetters("ChatbotState", {
            settingsChatbot: "getSettings",
          }
      ),
      settingsCategories() {
        return this.settingsCategoriesAll[this.userInfo.role];
      },
      generalAvailableLocales: function () {
        return this.availableLocales.filter(function (element) {
          return element.locale !== 'auto';
        })
      },
      generalNotificationsType: function () {
        return this.availableNotificationsType.filter(function (element) {
          return element.locale !== 'auto';
        })
      },
      chatbotAvailableLocales: function () {
        return this.availableLocales.filter(function (element) {
          return element.locale === 'en'
              || element.locale === 'it'
          //|| element.locale === 'auto'
        })
      },
      chatbotAudioAvailableLocales: function () {
        return this.availableLocales.filter(function (element) {
          return element.locale === 'en'
              || element.locale === 'it'
        })
      }
    },

    watch: {
      notificationsIndustry: {
        handler: function (value, oldValue) {
          this.selectedAllMarkets = value === this.markets;
        }
      },
      notificationsTech: {
        handler: function (value, oldValue) {
          this.selectedAllTechs = value === this.technologies;
        }
      },
      notificationsOpco: {
        handler: function (value, oldValue) {
          this.selectedAllOpcos = value === this.opcos;
        }
      },
    },

    methods: {
      selectAllMarket() {
        if (_.isEqual(this.notificationsIndustry,this.markets)) {
          this.notificationsIndustry = [];
          this.selectedAllMarkets = false;
        } else {
          this.notificationsIndustry = this.markets;
          this.selectedAllMarkets = true;
        }
      },

      selectAllTech() {
        if (_.isEqual(this.notificationsTech,this.technologies)) {
          this.notificationsTech = [];
          this.selectedAllTechs = false;
        } else {
          this.notificationsTech = this.technologies;
          this.selectedAllTechs = true;
        }
      },

      selectAllOpco() {
        if (_.isEqual(this.notificationsOpco,this.opcos)) {
          this.notificationsOpco = [];
          this.selectedAllOpcos = false;
        } else {
          this.notificationsOpco = this.opcos;
          this.selectedAllOpcos = true;
        }
      },

      changeCountry() {
        return this.notificationsCountry
      },

      changeIndustry() {
        return this.notificationsIndustry
      },

      changeTech() {
        return this.notificationsTech
      },

      changeOpco() {
        return this.notificationsOpco
      },

      selectSettingsCategory(settingsCategory) {
        for (let i = 0; i < this.settingsCategories.length; i++) {
          if (this.settingsCategories[i].id === settingsCategory.id) {
            this.settingsCategories[i].active = true;
          } else {
            this.settingsCategories[i].active = false;
          }
        }
        this.selectedSettingsCategory = settingsCategory;
      },


      /**
       * Save or discard (and exit)
       */
      discardAndExit() {
        SettingsService.discard();
        RouterService.goBack();
      },
      saveAndExit() {
        this.userChatbotSettings.notificationsCountry = this.checkboxCountry ? this.notificationsCountry : null,
        console.log("save & exit: ", this.notificationsIndustry)
        this.userChatbotSettings.notificationsIndustry = this.checkboxIndustry ? this.notificationsIndustry : null,
        this.userChatbotSettings.notificationsTech = this.checkboxTech ? this.notificationsTech : null,
        this.userChatbotSettings.notificationsOpco = this.checkboxOpco ? this.notificationsOpco : null,
        SettingsService.save();
        RouterService.goBack();
        this.settingsChatbot.toBeInitialized = true;
        this.$store.dispatch("ChatbotState/setSettings", this.settingsChatbot);
        this.saveUserSettings();
      },
      /**
       * Handle temporary Settings
       */
      saveUserSettings() {
        let currentSelection = this.$refs.notificationsTypeSelection.getCurrentSelection();
        let requestUrl = {
          url: UrlsService.userSettings,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          interactionData: {
            userSettingsRequest: {
              buttons: this.userChatbotSettings.buttons,
              notificationsType: currentSelection.value,
              chatLanguage: this.settings.chatbot.language.current.locale,
              notificationsCountry: this.userChatbotSettings.notificationsCountry,
              notificationsIndustry: this.userChatbotSettings.notificationsIndustry,
              notificationsTech: this.userChatbotSettings.notificationsTech,
              notificationsOpco: this.userChatbotSettings.notificationsOpco,
            }
          },
        };
        let requestObject = {
          type: "normal",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
          },
        };
        let messages = {
          title: "Save user settings",
          loading: "Waiting for saving...",
          error: "Cannot complete the saving...",
        };
        let options = {
          loadingType: "notification",
          timeout: TimeService.secondsToMillis(60),
        };
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {
              this.userChatbotSettings.notificationsType.current.value = currentSelection.value
              this.userChatbotSettings.notificationsType.current.description = currentSelection.name
              this.$store.dispatch("AppState/setSettings", this.userChatbotSettings);

            }).catch(responseError => {
        });
      },
      changeLocale(selectedLanguage) {
        i18n.locale = selectedLanguage.locale;
        this.settings.general.language.current = selectedLanguage;
      },
      setChatbotLocale(selectedLanguage) {
        this.settings.chatbot.language.current = selectedLanguage;
      },
      setChatbotEngine(selectedEngine) {
        this.settings.chatbot.engine.current = selectedEngine;
      },
      setChatbotAudioLocale(selectedAudioLanguage) {
        this.settings.chatbot.audio.language.current = selectedAudioLanguage;
      },

      getMarkets() {
        let requestUrl = {
          url: UrlsService.getTagsSuggestion,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          interactionData: {
            text: "",
            elasticSearchRequest: {
              pageSize: 1000,
              pageNumber: 0
            }
          },
        };
        let requestObject = {
          type: "normal",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
          },
        };
        let messages = {
          title: "List get Markets ",
          error: "Error get Markets...",
        };
        let options = {
          loadingType: "fullscreen",
          timeout: TimeService.secondsToMillis(0),
        };
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {

              let responseMarket = responseSuccess.response.markets;
              if (responseMarket !== undefined) {
                for (let i = 0; i < responseMarket.length; i++) {
                  this.markets[i] = responseMarket[i].value
                }

                console.log("markets: ",this.markets);
                console.log(this.notificationsIndustry);
                console.log(this.notificationsIndustry===this.markets)
                if (_.isEqual(this.notificationsIndustry,this.markets)) {
                  this.selectedAllMarkets = true;
                }
              }

            });
      },

      getOpcos() {
        let requestUrl = {
          url: UrlsService.getTagsSuggestion,
          timeout: TimeService.secondsToMillis(0),
        };
        let requestData = {
          interactionData: {
            text: "",
            elasticSearchRequest: {
              pageSize: 1000,
              pageNumber: 0
            }
          },
        };
        let requestObject = {
          type: "normal",
          urlsInfo: requestUrl,
          data: {
            data: requestData,
          },
        };
        let messages = {
          title: "List get OpCos ",
          error: "Error get OpCos...",
        };
        let options = {
          loadingType: "fullscreen",
          timeout: TimeService.secondsToMillis(0),
        };
        APILoaderDecoratorService.setLoader(requestObject, messages, options)
            .then(responseSuccess => {

              let responseOpco = responseSuccess.response.opcos;
              if (responseOpco !== undefined) {
                for (let i = 0; i < responseOpco.length; i++) {
                  this.opcos[i] = responseOpco[i].value
                }
                if (_.isEqual(this.notificationsOpco,this.opcos)) {
                  this.selectedAllOpcos = true;
                }
              }

            });
      },

      /*
      countryErrors() {
        const errors = [];
        if (!this.checkValidItemBoolean(this.country, this.countries)) {
          let error = "Value " + this.checkValidItem(this.country, this.countries) + " saved in DB is not valid!"
          errors.push(error)
        } else {
          this.country = this.checkValidItem(this.country, this.countries)
        }
        return errors;
      },
      checkValidItemBoolean(item, items) {
        for (let i = 0; i < items.length; i++) {
          if (item === undefined || items === undefined || item === "" || item === "-") return true;
          if (item.toLowerCase() === items[i].toLowerCase()) {
            item = items[i];
            return true;
          }
        }
        return false;
      },
      checkValidItem(item, items) {
        for (let i = 0; i < items.length; i++) {
          if (item.toLowerCase() === items[i].toLowerCase()) {
            item = items[i];
            break;
          }
        }
        return item;
      },
      */
    }
  }
  </script>

  <style lang="scss">
  .selected-item {
    background-color: rgba(240, 240, 240, 1);
  }
  .email {
    .v-list__tile__content{
      justify-content: center;
      flex-direction: row;
      text-align: center;
      align-items: center;
      vertical-align: center;
    }
  }
  .v-messages{
    min-height: 0;
  }

  </style>
